import React, { Fragment } from "react";

import img13 from "../../../images/service/Crypto Listing/1.png";
import img14 from "../../../images/service/Crypto Listing/2.png";
import img15 from "../../../images/service/Crypto Listing/3.png";

import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import ProcessTimeline from "../../../components/PageSection/ProcessTimeline";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "Centralized Exchange Listing",
    content:
      "Token and coin listing services on leading centralized exchanges with end-to-end coordination.",
  },
  {
    icon: sIcon2,
    title: "Decentralized Exchange Listing",
    content:
      "DEX listing support including liquidity pool setup and smart contract verification.",
  },
  {
    icon: sIcon3,
    title: "Launchpad & IEO Support",
    content:
      "End-to-end support for IEO, IDO, IGO, and launchpad-based token listings.",
  },
];

const listingProcess = [
  {
    index: "01",
    title: "Project Evaluation",
    description: "We assess your token, roadmap, and exchange readiness.",
  },
  {
    index: "02",
    title: "Documentation & Compliance",
    description: "Whitepaper, tokenomics, and listing documents prepared.",
  },
  {
    index: "03",
    title: "Exchange Coordination",
    description: "Direct coordination with CEXs, DEXs, and launchpads.",
  },
  {
    index: "04",
    title: "Liquidity Setup",
    description: "Liquidity pools, market making, and trading readiness.",
  },
  {
    index: "05",
    title: "Listing & Launch",
    description: "Token goes live with monitoring and post-launch support.",
  },
];


const benefits = [
  {
    title: "Increased Market Visibility",
    description:
      "Exchange listings expose your token to a global investor audience.",
    icon: sIcon1,
  },
  {
    title: "Improved Liquidity",
    description:
      "Listings enable active trading and price discovery.",
    icon: sIcon2,
  },
  {
    title: "Investor Trust",
    description:
      "Exchange vetting improves credibility and confidence.",
    icon: sIcon3,
  },
  {
    title: "Global Reach",
    description:
      "Access international markets and trading communities.",
    icon: sIcon4,
  },
  {
    title: "Faster Adoption",
    description:
      "Easy access for users accelerates adoption.",
    icon: sIcon5,
  },
  {
    title: "Strategic Growth",
    description:
      "Listings support ecosystem expansion and partnerships.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is crypto listing?",
    a: "Crypto listing is the process of making a token or coin tradable on an exchange platform.",
  },
  {
    q: "Do you support both CEX and DEX listings?",
    a: "Yes. We support centralized exchanges, decentralized exchanges, and launchpads.",
  },
  {
    q: "How long does the listing process take?",
    a: "Timelines vary based on exchange requirements, but we streamline the process for faster approvals.",
  },
  {
    q: "Do you assist with liquidity?",
    a: "Yes. We help with liquidity pool setup and market-making coordination.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function CryptoListingServices() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Crypto Listing Services"
        pagesub="Get your token listed and visible across global exchanges"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Professional{" "}
            <span className="gradient-text">Crypto Listing Services</span>
          </>
        }
        subtitle={`Crypto listings are a crucial milestone for any blockchain project.
We help startups and enterprises list their tokens across top exchanges,
launchpads, and trading platforms with confidence.`}
        buttonText="List My Token"
        buttonLink="/contact"
        image={img13}
        imageAlt="Crypto Listing Services"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Are Crypto Listing Services?"
        image={img14}
        paragraphs={[
          "Crypto listing services help blockchain projects make their tokens or coins tradable on cryptocurrency exchanges. This process involves technical validation, compliance checks, liquidity preparation, and coordination with exchange platforms.",
          "A successful listing ensures that your token reaches the right audience, gains liquidity, and establishes market credibility. Strategic listing decisions play a vital role in long-term project success.",
        ]}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Exchange Listings Matter for Growth"
        image={img15}
        paragraphs={[
          "Without exchange listings, tokens remain inaccessible to most users. Listings unlock market participation by enabling trading, price discovery, and broader adoption.",
          "For projects, listings are not just about visibility—they signal legitimacy, readiness, and long-term vision. Well-planned listings can accelerate ecosystem growth and investor engagement.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our Crypto Listing Services"
        cards={serviceCards}
      />

      {/* ================= PROCESS TIMELINE ================= */}
      <ProcessTimeline
        title="Our Crypto Listing Process"
        steps={listingProcess}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of Crypto Listing Services"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of Our Listing Support"
        subtitle="Strategic, compliant, and growth-focused listing solutions."
        features={[
          {
            icon: sIcon1,
            title: "Exchange Coordination",
            description:
              "Direct coordination with exchange teams.",
          },
          {
            icon: sIcon2,
            title: "Technical Validation",
            description:
              "Smart contract and token standard checks.",
          },
          {
            icon: sIcon3,
            title: "Liquidity Planning",
            description:
              "Liquidity pool and market-making strategy.",
          },
          {
            icon: sIcon4,
            title: "Compliance Assistance",
            description:
              "Support for listing requirements and documentation.",
          },
          {
            icon: sIcon5,
            title: "Multi-Exchange Strategy",
            description:
              "Listing roadmap across multiple platforms.",
          },
          {
            icon: sIcon6,
            title: "Post-Listing Support",
            description:
              "Ongoing support after token goes live.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Strong Exchange Network",
          "End-to-End Listing Support",
          "Strategic Market Expertise",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
